import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import {
    RuntimePresentationView,
    RuntimeInteractiveBlockView,
} from './RuntimeScenarioViews';

/**
 * Lightweight learner-style preview for hosts without LMS (e.g. super admin).
 * Shows presentation and each interactive block in order using the same runtime
 * widgets as the editor canvas.
 */
export function SimpleQuestionPreviewModal({ question, onClose }) {
    const ui = question?.ui || {};
    const presentation = ui.presentation ?? null;
    const blocks = Array.isArray(ui.blocks) ? ui.blocks : [];

    return (
        <Dialog
            open
            onClose={onClose}
            maxWidth="md"
            fullWidth
            scroll="paper"
        >
            <DialogTitle>
                Preview: {question?.name || 'Question'}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Simplified preview: presentation and blocks in scenario order
                    (same widgets as the canvas). This is not the full LMS learner
                    flow.
                </Typography>

                <Box
                    sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 1,
                        p: 2,
                        mb: 2,
                        bgcolor: 'background.paper',
                    }}
                >
                    <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                        Presentation
                    </Typography>
                    <RuntimePresentationView presentation={presentation} />
                </Box>

                {blocks.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No interactive blocks yet.
                    </Typography>
                ) : (
                    blocks.map((block, i) => (
                        <Box
                            key={block.id || `block-${i}`}
                            sx={{
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                p: 2,
                                mb: 2,
                                bgcolor: 'background.paper',
                            }}
                        >
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                                gutterBottom
                            >
                                Block {i + 1} of {blocks.length} · {block.type}
                            </Typography>
                            <RuntimeInteractiveBlockView block={block} />
                        </Box>
                    ))
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
